import cookieJson from "virtual:dev-cookie";
import { AnalysisService } from "@/plugins/analysis";
import { useUserStore } from "@/stores/user";
import { initAppEnvironment } from "@/utils/initAppEnvironment";
import { initMiniProgramEnvironment, EnvironmentInitResult } from "@/utils/initMiniProgramEnvironment";
import Util from "@/utils/util";
import userBiz from "@/process/userBiz";

export async function initializeEnvironment(options?: { isInApp?: boolean; isInMiniProgram?: boolean }): Promise<EnvironmentInitResult> {
  const isInApp = options?.isInApp || false;
  const isInMiniProgram = options?.isInMiniProgram || false;

  if (isInApp) {
    return initAppEnvironment();
  }

  if (isInMiniProgram) {
    return initMiniProgramEnvironment();
  }

  if (import.meta.env.VITE_APP_LOCAL_ENV === "dev") {
    return initLocalDevEnvironment();
  }

  return {
    env: "other",
    isLogin: false,
    isVip: false,
    productID: 0,
  };
}

async function initLocalDevEnvironment(): Promise<EnvironmentInitResult> {
  const userStore = useUserStore();

  // 开发环境（本地环境）下，在非 app 环境中模拟登录
  // 从环境变量获取用户标识，默认使用当前 ENV 下的 default 用户
  let cookieUser = import.meta.env.VITE_APP_COOKIE_USER || "default";
  const envCookie = cookieJson[import.meta.env.VITE_APP_ENV];

  console.warn(`------开发环境（本地环境）下，在非app环境中模拟[${cookieUser}]登录------`);

  if (!envCookie[cookieUser]) {
    console.error(`Cookie.json 中没有当前环境【${import.meta.env.VITE_APP_ENV}】下，用户 "${cookieUser}" 的配置，切换至用户【default】`);
    cookieUser = "default";
  }

  const data = envCookie[cookieUser].reduce((pre: { [key: string]: string }, current: { name: string; value: string }) => {
    return {
      ...pre,
      [current.name]: decodeURIComponent(current.value),
    };
  }, {});

  const headerInfo = {
    enCryptType: data.Client_EncryptType,
    headInfo: data.ClientHeaderInfo,
    productId: data.Client_ProductID,
  };

  userStore.setVipState(false);
  userStore.setLoginState(1);
  userStore.setHeaderInfo(
    Object.assign({}, headerInfo, {
      domain: window.location.host.indexOf("babybus") > -1 ? ".babybus.com" : location.hostname,
    }),
  );

  // 服务端不让启动调用积分接口，总有一天要调回来，哼
  // userStore.fetchAccountIntegral();
  userStore.fetchUserInfo().finally(() => {
    AnalysisService.setUserInfo(userStore.userInfo);
  });
  // 账号事件数据上报（每天仅一次），透传当前页面全量 query
  userBiz.reportAccountEventData(Util.parseQuery(location.search));

  return {
    env: "devMock",
    isLogin: true,
    isVip: false,
    productID: data.Client_ProductID || 0,
  };
}
